import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* 品牌資訊 */}
          <div>
            <img 
              src="https://static.readdy.ai/image/4f3f06d226654fda02a3ba64a379f0f2/85b2a998400146a99430a443824c5c33.jpeg" 
              alt="laigame手遊代儲"
              className="h-12 w-auto object-contain mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              專業手遊代儲平台，提供安全、快速、優惠的遊戲儲值服務。SSL加密保護，帳密閱後即焚，0鎖號保證。
            </p>
            <div className="flex gap-3">
              <a 
                href="https://line.me/R/ti/p/@laigame" 
                target="_blank" 
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-green-500 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
                aria-label="LINE"
              >
                <i className="ri-line-fill text-xl"></i>
              </a>
              <a 
                href="https://www.facebook.com/laigame" 
                target="_blank" 
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-blue-500 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* 快速連結 */}
          <div>
            <h3 className="text-lg font-bold mb-4">快速連結</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/order" className="text-gray-400 hover:text-white transition-colors text-sm">
                  立即下單
                </Link>
              </li>
              <li>
                <Link to="/agent" className="text-gray-400 hover:text-white transition-colors text-sm">
                  代理回饋制度
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-white transition-colors text-sm">
                  購物 Q&amp;A
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors text-sm">
                  聯絡我們
                </Link>
              </li>
              <li>
                <Link to="/account" className="text-gray-400 hover:text-white transition-colors text-sm">
                  會員中心
                </Link>
              </li>
            </ul>
          </div>

          {/* 客戶服務 */}
          <div>
            <h3 className="text-lg font-bold mb-4">客戶服務</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm">
                <i className="ri-time-line text-green-400 mt-0.5"></i>
                <div>
                  <div className="text-gray-400">服務時間</div>
                  <div className="text-white font-medium">24小時全年無休</div>
                </div>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <i className="ri-phone-line text-blue-400 mt-0.5"></i>
                <div>
                  <div className="text-gray-400">客服專線</div>
                  <a href="tel:+886984189784" className="text-white font-medium hover:text-blue-400 transition-colors">
                    0984-189784
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <i className="ri-line-fill text-green-400 mt-0.5"></i>
                <div>
                  <div className="text-gray-400">LINE客服</div>
                  <a 
                    href="https://line.me/R/ti/p/@laigame" 
                    target="_blank" 
                    rel="nofollow noopener noreferrer"
                    className="text-white font-medium hover:text-green-400 transition-colors"
                  >
                    @laigame91
                  </a>
                </div>
              </li>
            </ul>
          </div>

          {/* 法律條款 */}
          <div>
            <h3 className="text-lg font-bold mb-4">法律條款</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-white transition-colors text-sm">
                  服務條款
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors text-sm">
                  隱私權政策
                </Link>
              </li>
            </ul>
            <div className="mt-6">
              <h4 className="text-sm font-bold mb-2">安全保障</h4>
              <div className="flex flex-wrap gap-2">
                <span className="px-3 py-1 bg-green-500/20 text-green-400 rounded-full text-xs font-medium">
                  SSL加密
                </span>
                <span className="px-3 py-1 bg-blue-500/20 text-blue-400 rounded-full text-xs font-medium">
                  0鎖號保證
                </span>
                <span className="px-3 py-1 bg-purple-500/20 text-purple-400 rounded-full text-xs font-medium">
                  即焚機制
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* 底部版權 */}
        <div className="border-t border-gray-700 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>© 2024 laigame手遊代儲. All rights reserved.</p>
            <p className="text-xs">
              本站提供專業手遊代儲服務，保證安全快速到帳
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}